(function($) {
    var $fn = $("#layout_header"),
        pointerMovementDetected = false;

    if ($fn.length) {
        $("#layout_nav").slideAndSwipe();

        function setMenuOpen($parent, open) {
            if (open) {
                $parent.attr("data-open", "");
                $parent.find("[data-menu-root]").attr("data-open", "");
            } else {
                $parent.removeAttr("data-open");
                $parent.find("[data-menu-root]").removeAttr("data-open");
            }

            $parent
                .find("[data-menu-toggle]")
                .attr("aria-expanded", open ? "true" : "false");
        }

        function activateTrigger($trigger) {
            var $trigger = $(this),
                $root = $trigger.closest("[data-menu-root]"),
                target = $trigger.data("menu-trigger");

            if (!$root.length || !target) {
                return;
            }

            $trigger
                .closest(".elm_dropdown_categories, .elm_dropdown_section")
                .find("a")
                .removeAttr("data-active");

            $trigger
                .attr("data-active", "")
                .attr("aria-expanded", "true");

            $trigger
                .closest(".elm_dropdown_categories, .elm_dropdown_section")
                .find("[data-menu-trigger]")
                .not($trigger)
                .attr("aria-expanded", "false");

            var $panel = $root.find('[data-menu-panel="' + target + '"]'),
                isLevel3 = $trigger.closest(".elm_dropdown_section").length > 0,
                hasLevel4 = !isLevel3 || ($panel.length && $panel.find("a").length);

            $panel
                .attr("data-active", "")
                .removeAttr("hidden")
                .siblings("[data-menu-panel]")
                .removeAttr("data-active")
                .attr("hidden", "hidden");

            if (isLevel3) {
                if (hasLevel4) {
                    $root.find(".elm_dropdown_links, .elm_dropdown_divider_links").removeAttr("hidden");
                } else {
                    $root.find(".elm_dropdown_links, .elm_dropdown_divider_links").attr("hidden", "hidden");
                }
            } else {
                // categories-level trigger: make sure the section column is visible
                // again (a childless category hover may have hidden it)
                $root.find(".elm_dropdown_section, .elm_dropdown_divider_section").removeAttr("hidden");

                // reset the links column - re-shown below only if the newly active
                // section (if any) actually has one, otherwise it stays hidden
                // instead of leaking the previous category's stale links
                $root.find(".elm_dropdown_links [data-menu-panel]").removeAttr("data-active").attr("hidden", "hidden");
                $root.find(".elm_dropdown_links, .elm_dropdown_divider_links").attr("hidden", "hidden");
            }

            // prefer the nested trigger on the current page's branch (still
            // carrying its server-rendered data-active), else fall back to first
            var $nextTrigger = $panel.find("[data-menu-trigger][data-active]").first();

            if (!$nextTrigger.length) {
                $nextTrigger = $panel.find("[data-menu-trigger]").first();
            }

            if ($nextTrigger.length) {
                activateTrigger.call($nextTrigger[0]);
            }
        }

        function focusInColumn($items, current, direction) {
            if (!$items.length) {
                return;
            }

            var index = $items.index(current),
                next = (index + direction + $items.length) % $items.length;

            $items.eq(next).focus();
        }

        // A browser can place the pointer over a menu item before this script is
        // initialized (typically after a refresh). Do not treat that initial
        // position as an intentional hover; wait for real pointer movement.
        $(document).one("mousemove.layoutHeaderMenu", function(e) {
            var $parent = $(e.target).closest("[data-menu-parent]");

            pointerMovementDetected = true;

            if ($parent.closest("#layout_header").is($fn)) {
                setMenuOpen($parent, true);
            }
        });

        $fn.find("[data-menu-parent]").each(function() {
            setMenuOpen($(this), false);
        });

        $fn.on("mouseenter", "[data-menu-parent]", function() {
            if (pointerMovementDetected) {
                setMenuOpen($(this), true);
            }
        });

        $fn.on("focusin", "[data-menu-parent]", function() {
            setMenuOpen($(this), true);
        });

        $fn.on("mouseleave focusout", "[data-menu-parent]", function() {
            var $parent = $(this);

            window.setTimeout(function() {
                if ((!pointerMovementDetected || !$parent.is(":hover")) && !$parent.has(document.activeElement).length) {
                    setMenuOpen($parent, false);
                }
            }, 0);
        });

        $fn.on("mouseenter focusin", "[data-menu-trigger]", activateTrigger);

        $fn.on("mouseenter focusin", ".elm_dropdown_section a:not([data-menu-trigger])", function() {
            var $trigger = $(this),
                $root = $trigger.closest("[data-menu-root]");

            $trigger
                .closest(".elm_dropdown_section")
                .find("a")
                .removeAttr("data-active");

            $trigger.attr("data-active", "");

            $root.find(".elm_dropdown_links [data-menu-panel]").removeAttr("data-active").attr("hidden", "hidden");
            $root.find(".elm_dropdown_links, .elm_dropdown_divider_links").attr("hidden", "hidden");
        });

        // category with no level-3: clear & hide the leftover section + links columns
        $fn.on("mouseenter focusin", ".elm_dropdown_categories a:not([data-menu-trigger])", function() {
            var $trigger = $(this),
                $root = $trigger.closest("[data-menu-root]");

            $trigger
                .closest(".elm_dropdown_categories")
                .find("a")
                .removeAttr("data-active");

            $trigger.attr("data-active", "");

            $root.find("[data-menu-panel]").removeAttr("data-active").attr("hidden", "hidden");
            $root.find(".elm_dropdown_section, .elm_dropdown_divider_section, .elm_dropdown_links, .elm_dropdown_divider_links").attr("hidden", "hidden");
        });

        $fn.on("keydown", "[data-menu-toggle]", function(e) {
            var $parent = $(this).closest("[data-menu-parent]");

            if (e.key === "ArrowDown") {
                e.preventDefault();
                setMenuOpen($parent, true);
                $parent.find(".elm_dropdown_categories [data-active]").first().focus();
            } else if (e.key === "Escape") {
                $(this).focus();
                setMenuOpen($parent, false);
            }
        });

        $fn.on("keydown", "[data-menu-root] a", function(e) {
            var $link = $(this),
                $root = $link.closest("[data-menu-root]"),
                $parent = $link.closest("[data-menu-parent]");

            if (e.key === "Escape") {
                e.preventDefault();
                $parent.find("[data-menu-toggle]").focus();
                setMenuOpen($parent, false);
                return;
            }

            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                e.preventDefault();
                focusInColumn($link.closest("div, ul").find("a:visible"), this, e.key === "ArrowDown" ? 1 : -1);
                return;
            }

            if (e.key === "ArrowRight" && $link.is("[data-menu-trigger]")) {
                var target = $link.data("menu-trigger"),
                    $panel = $root.find('[data-menu-panel="' + target + '"]'),
                    $first = $panel.find("a:visible").first();

                if ($first.length) {
                    e.preventDefault();
                    $first.focus();
                }
                return;
            }

            if (e.key === "ArrowLeft") {
                var $column = $link.closest(".elm_dropdown_section, .elm_dropdown_links");

                if ($column.is(".elm_dropdown_section")) {
                    e.preventDefault();
                    $root.find(".elm_dropdown_categories [data-active]").first().focus();
                } else if ($column.is(".elm_dropdown_links")) {
                    e.preventDefault();
                    $root.find(".elm_dropdown_section [data-active]").first().focus();
                }
            }
        });

        $fn.find("[data-menu-root]").each(function() {
            var $root = $(this),
                rootId = $root.attr("id") || "layout-header-menu",
                $active = $root.find("[data-menu-trigger][data-active]").first();

            $root.find("[data-menu-panel]").each(function() {
                var $panel = $(this),
                    panel = $panel.data("menu-panel");

                $panel.attr("id", rootId + "-" + panel);
                if (!$panel.is("[data-active]")) {
                    $panel.attr("hidden", "hidden");
                }
            });

            $root.find("[data-menu-trigger]").each(function() {
                var $trigger = $(this),
                    target = $trigger.data("menu-trigger"),
                    $panel = $root.find('[data-menu-panel="' + target + '"]');

                if ($panel.length) {
                    $trigger
                        .attr("aria-expanded", $trigger.is("[data-active]") ? "true" : "false")
                        .attr("aria-controls", $panel.attr("id"));
                } else {
                    $trigger
                        .removeAttr("aria-expanded")
                        .removeAttr("aria-controls");
                }
            });

            if (!$active.length) {
                // current page may be a category with no level-3 (not a trigger):
                // clear the section/links columns instead of opening the first one
                var $activeLeafCategory = $root
                    .find(".elm_dropdown_categories a[data-active]:not([data-menu-trigger])")
                    .first();

                if ($activeLeafCategory.length) {
                    $activeLeafCategory.trigger("mouseenter");
                    return;
                }

                $active = $root.find("[data-menu-trigger]").first();
            }

            if ($active.length) {
                activateTrigger.call($active[0]);
            }
        });

        function mobileAccordionToggles(panelId) {
            return $("#layout_nav").find('[data-mobile-accordion][aria-controls="' + panelId + '"]');
        }

        $("#layout_nav").find("[data-mobile-accordion]").each(function() {
            var panelId = $(this).attr("aria-controls"),
                $toggles = mobileAccordionToggles(panelId),
                $panel = $("#" + panelId),
                expanded = $toggles.filter('[aria-expanded="true"]').length > 0;

            $toggles.attr("aria-expanded", expanded ? "true" : "false");
            if (!expanded) {
                $panel.attr("hidden", "hidden").hide();
            }
        });

        $("#layout_nav").on("click", "[data-mobile-accordion]", function() {
            var panelId = $(this).attr("aria-controls"),
                $toggles = mobileAccordionToggles(panelId),
                $panel = $("#" + panelId),
                expanded = $(this).attr("aria-expanded") === "true";

            $toggles.attr("aria-expanded", expanded ? "false" : "true");
            if (expanded) {
                $panel.stop(true, true).slideUp(200, function() {
                    $panel.attr("hidden", "hidden");
                });
            } else {
                $panel.removeAttr("hidden").stop(true, true).slideDown(200);
            }
        });

        var headroom = new Headroom($fn[0], {
            offset: 5,
            tolerance : {
                up : 5,
                down : 0
            },
            classes: {
                "initial" : "headroom",
                "pinned": "headroom--pinned",
                "unpinned": "headroom--unpinned",
                "top" : "headroom--top",
                "notTop" : "headroom--not-top"
            }
        });
        headroom.init();
    }
})(jQuery);
